
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexjIGeYSXWy2_N0nSVE9UpeKFKEqrbpIkXwS_453kr5ffDoMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/index.vue?macro=true";
import { default as builderGQfrnXTxioOFeHPdm_45c4IqbUruIK_WdwARk5a8uQGHgMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/builder.vue?macro=true";
import { default as _91id_93cnwvSldFKrFHMQC4M0as92zBz17l3EaQy6viZdqnSdcMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/news/[id].vue?macro=true";
import { default as _91id_93oyRjfMB6_Du9r1xnL0BNXiQg73zds5FWbHlpwA3HkHUMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/class/[id].vue?macro=true";
import { default as indexnrb0W7rJ5lBkZ6dd_mUi5s5_45FzCNN_HBxvvKSZ1AXV0Meta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/news/index.vue?macro=true";
import { default as _91id_93KSeC5QjN23I1rkM4a4X_45mgWJJjNbvgfPwhuoBi02gCAMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/order/[id].vue?macro=true";
import { default as indexwnKBnWNeZsdwV0aqIWhzzAKL7oOHW85WNihDsoxIUU0Meta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/role/index.vue?macro=true";
import { default as indexGwrIfu0vshp_457BPl0DXvCRhDOiiWBU4c_yik4fDYUS4Meta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/class/index.vue?macro=true";
import { default as indexJWe14r4O1U8Z460CUHIKwxGNDgiN_45q8TNSSmHzDmatQMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/order/index.vue?macro=true";
import { default as createaGV1a36SajPolpBYyNQtCbcuiwHSIMjhaEWfRZvGRlUMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/class/create.vue?macro=true";
import { default as _91id_93FIjTa0aqXue4Bzgw4rMUlGKgTD7atcRfg9KExCUU2yIMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/gallery/[id].vue?macro=true";
import { default as indexHo8TC9vtwR_kZj8O_451uDkJGBpV8_453igE9a4GcZXT_OMMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/module/index.vue?macro=true";
import { default as indexUOB4mYfnurzGqQJWuF8p1CcF_451_eV_nG7cP4AF1RdwcMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/office/index.vue?macro=true";
import { default as _91id_93NpdcB3aXZd3FkXtDT5nrT1ShfaddV_YGOnICfzHZDzoMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/product/[id].vue?macro=true";
import { default as indexia_sStxfh1sfJJYYtAKSKHzRzi_45AQrQChKS6UTh6mKIMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/school/index.vue?macro=true";
import { default as indexgy1MGzXUKCNAGK_xDWVJSNQZA7UBTL7SXGW8vUgp7dEMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/account/index.vue?macro=true";
import { default as loginIUT1NY7Cal4raNCKKJ5Ah9wES8QMf4_5XHzuAQB55PcMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/account/login.vue?macro=true";
import { default as _91id_93PgysDgdNSeTR74jpUx6yw8EJVApvtt9Fkco6bdIUbvMMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/activity/[id].vue?macro=true";
import { default as indexQzKl4vK5zMPaiembxqKDYqihCV1FyzoI09fUV6EUeSQMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/contact/index.vue?macro=true";
import { default as indexOzcCazUDqYqhRWpeHEwRpsbdFD62wA3GWQ3oSR9N9eMMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/gallery/index.vue?macro=true";
import { default as index2xvhgtR7j7bSPpXnX_lx0IQEzi4uOuBfKwN8F7LDIKUMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/product/index.vue?macro=true";
import { default as indext_45b0wfHwVFOihQY6TGKkOHAfRIqHDL3u7qDzrt7K8zwMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/activity/index.vue?macro=true";
import { default as indexp6g4tOaR7QAOExkzaehgsI11qtc6220xZIvkF7WokI4Meta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/language/index.vue?macro=true";
import { default as index9OmcUNp6hInCiHoSEW4gMqF_45mmapsuMy72mIaKqNxywMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/locality/index.vue?macro=true";
import { default as pdf2imageQcggGWgboo7HRArnu_4_45c44wJ8eamRQ6_oB7U_45NOnPAMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/test/pdf2image.vue?macro=true";
import { default as index_45zihICzfD_KEOxorU_45ulw0EO2A0Ie400l1Z_45arIslfMMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/ai-prompt/index.vue?macro=true";
import { default as _91code_93O_2sVlU9rKXUCrYlrku9M7o1_456N2GslbDc0K02GyTwAMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/category/[code].vue?macro=true";
import { default as settingswAnSvIQGFlUgZ8VJVtn9REAY58Y3VkvFfNvy6Sc0zqQMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/account/settings.vue?macro=true";
import { default as indexiYiEWFU2xpraNmWCSco4W36kfSq0q6w4INg43Ga_yw4Meta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/exam-share/index.vue?macro=true";
import { default as indexuvYmZLHgUTz7Gspnulg_45dWNtYLbsPwh7V1XF7c78E7EMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/action-rule/index.vue?macro=true";
import { default as indexh4d3_45jfQq3940vxovHdbnVaOHa4Mr95uL_45ReTTJyQXcMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/static-page/index.vue?macro=true";
import { default as file_45managerHYfKmupzoiSHzkXua43vou8ASQX9UUybGd4uS2BIW2IMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/test/file-manager.vue?macro=true";
import { default as indexNMaZ060FYcr5Yyb_FQGX5AvP4shs6DWL3vWnA5r2rikMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/translation/index.vue?macro=true";
import { default as indexceQiMVFY7HIeEtT8RcS0BtkwnFkNxgpJW_45tYxkSwWJUMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/activity-log/index.vue?macro=true";
import { default as indexghn5CRgx1k23EJlPeItiQmEUUo1G7G3i_Bk2tu_r1fQMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/organization/index.vue?macro=true";
import { default as indexR4VHKEvNc8sbcbAz_453tms6ajj0v68Sh5XJvOJcgPcMgMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/academic-year/index.vue?macro=true";
import { default as index4gu4OJ7tzmmzt2v_45gG4aovdJNpBLM335qsIKHSO_LUoMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/system-config/index.vue?macro=true";
import { default as indexK3ny9WeG15_45RrvVj9LKTxIqukpVUi0YdNTSiNBgo3jwMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/product-review/index.vue?macro=true";
import { default as index83lUBCfXIxksS2L4J_0lSCF0zlXp8VWajizo8bwPngEMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/question-share/index.vue?macro=true";
import { default as org_45structuresTJn_iukS_45bmZj_45jXtkgnQALApWIQ2HPCxlKM5n9G_4Meta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/school/org-structure.vue?macro=true";
import { default as indexgTkDDdtU8xw20AitmoG2ccMW3A9E_453VbGlzQV5zsDMoMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/category-config/index.vue?macro=true";
import { default as indexH71l2IuH_45_wg8d4Ck_85HUZti6Bh_45DaAD2gqjmlgDQQMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/user-identifier/index.vue?macro=true";
import { default as indexK96lpby8cqKZYVsEUffCaRZGfLb6Tc104Yl59m_p4gIMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/tracking/leaderboard/index.vue?macro=true";
import { default as indexxCTpvIpI2QSv9KNZaOmaJEJMZpxSq6a7UIw7qTljXzgMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/static-page/[pageKey]/index.vue?macro=true";
import { default as indexmoHpZU3x_grHAWlPebYoAEpbv_45qj_aOO_45Rd_nCikQdYMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/tracking/activity-log/index.vue?macro=true";
import { default as indexkWuqVWs0XdqTjA_45b52p_45RBu3vjBQLroK0u6W_45jInTB0Meta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/tracking/activity-stats/index.vue?macro=true";
import { default as indexR52nO2JWw0ky_0ypnyM7lw5uUaJg0vivSST8Bwrh2xIMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/consultation-registration/index.vue?macro=true";
import { default as _91sectionKey_938eaeFkIJ6pIm8_45PdahKd_raA9kvYaDwisR5JbG8B41MMeta } from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/static-page/[pageKey]/[sectionKey].vue?macro=true";
export default [
  {
    name: "index___vi",
    path: "/",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/index.vue")
  },
  {
    name: "builder___vi",
    path: "/builder",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/builder.vue")
  },
  {
    name: "builder___en",
    path: "/en/builder",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/builder.vue")
  },
  {
    name: "news-id___vi",
    path: "/news/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/news/[id].vue")
  },
  {
    name: "news-id___en",
    path: "/en/news/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/news/[id].vue")
  },
  {
    name: "class-id___vi",
    path: "/class/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/class/[id].vue")
  },
  {
    name: "class-id___en",
    path: "/en/class/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/class/[id].vue")
  },
  {
    name: "news___vi",
    path: "/news",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/news/index.vue")
  },
  {
    name: "order-id___vi",
    path: "/order/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/order/[id].vue")
  },
  {
    name: "order-id___en",
    path: "/en/order/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/order/[id].vue")
  },
  {
    name: "role___vi",
    path: "/role",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/role/index.vue")
  },
  {
    name: "role___en",
    path: "/en/role",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/role/index.vue")
  },
  {
    name: "class___vi",
    path: "/class",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/class/index.vue")
  },
  {
    name: "class___en",
    path: "/en/class",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/class/index.vue")
  },
  {
    name: "order___vi",
    path: "/order",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/order/index.vue")
  },
  {
    name: "order___en",
    path: "/en/order",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/order/index.vue")
  },
  {
    name: "class-create___vi",
    path: "/class/create",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/class/create.vue")
  },
  {
    name: "class-create___en",
    path: "/en/class/create",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/class/create.vue")
  },
  {
    name: "gallery-id___vi",
    path: "/gallery/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/gallery/[id].vue")
  },
  {
    name: "gallery-id___en",
    path: "/en/gallery/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/gallery/[id].vue")
  },
  {
    name: "module___vi",
    path: "/module",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/module/index.vue")
  },
  {
    name: "module___en",
    path: "/en/module",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/module/index.vue")
  },
  {
    name: "office___vi",
    path: "/office",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/office/index.vue")
  },
  {
    name: "office___en",
    path: "/en/office",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/office/index.vue")
  },
  {
    name: "product-id___vi",
    path: "/product/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/product/[id].vue")
  },
  {
    name: "product-id___en",
    path: "/en/product/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/product/[id].vue")
  },
  {
    name: "school___vi",
    path: "/school",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/school/index.vue")
  },
  {
    name: "school___en",
    path: "/en/school",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/school/index.vue")
  },
  {
    name: "account___vi",
    path: "/account",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/account/index.vue")
  },
  {
    name: "account-login___vi",
    path: "/account/login",
    meta: loginIUT1NY7Cal4raNCKKJ5Ah9wES8QMf4_5XHzuAQB55PcMeta || {},
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/account/login.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: loginIUT1NY7Cal4raNCKKJ5Ah9wES8QMf4_5XHzuAQB55PcMeta || {},
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/account/login.vue")
  },
  {
    name: "activity-id___vi",
    path: "/activity/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/activity/[id].vue")
  },
  {
    name: "activity-id___en",
    path: "/en/activity/:id()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/activity/[id].vue")
  },
  {
    name: "contact___vi",
    path: "/contact",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/contact/index.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/contact/index.vue")
  },
  {
    name: "gallery___vi",
    path: "/gallery",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/gallery/index.vue")
  },
  {
    name: "gallery___en",
    path: "/en/gallery",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/gallery/index.vue")
  },
  {
    name: "product___vi",
    path: "/product",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/product/index.vue")
  },
  {
    name: "product___en",
    path: "/en/product",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/product/index.vue")
  },
  {
    name: "activity___vi",
    path: "/activity",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/activity/index.vue")
  },
  {
    name: "activity___en",
    path: "/en/activity",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/activity/index.vue")
  },
  {
    name: "language___vi",
    path: "/language",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/language/index.vue")
  },
  {
    name: "language___en",
    path: "/en/language",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/language/index.vue")
  },
  {
    name: "locality___vi",
    path: "/locality",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/locality/index.vue")
  },
  {
    name: "locality___en",
    path: "/en/locality",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/locality/index.vue")
  },
  {
    name: "test-pdf2image___vi",
    path: "/test/pdf2image",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/test/pdf2image.vue")
  },
  {
    name: "test-pdf2image___en",
    path: "/en/test/pdf2image",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/test/pdf2image.vue")
  },
  {
    name: "ai-prompt___vi",
    path: "/ai-prompt",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/ai-prompt/index.vue")
  },
  {
    name: "ai-prompt___en",
    path: "/en/ai-prompt",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/ai-prompt/index.vue")
  },
  {
    name: "category-code___vi",
    path: "/category/:code()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/category/[code].vue")
  },
  {
    name: "category-code___en",
    path: "/en/category/:code()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/category/[code].vue")
  },
  {
    name: "account-settings___vi",
    path: "/account/settings",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/account/settings.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/account/settings.vue")
  },
  {
    name: "exam-share___vi",
    path: "/exam-share",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/exam-share/index.vue")
  },
  {
    name: "exam-share___en",
    path: "/en/exam-share",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/exam-share/index.vue")
  },
  {
    name: "action-rule___vi",
    path: "/action-rule",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/action-rule/index.vue")
  },
  {
    name: "action-rule___en",
    path: "/en/action-rule",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/action-rule/index.vue")
  },
  {
    name: "static-page___vi",
    path: "/static-page",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/static-page/index.vue")
  },
  {
    name: "static-page___en",
    path: "/en/static-page",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/static-page/index.vue")
  },
  {
    name: "test-file-manager___vi",
    path: "/test/file-manager",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/test/file-manager.vue")
  },
  {
    name: "test-file-manager___en",
    path: "/en/test/file-manager",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/test/file-manager.vue")
  },
  {
    name: "translation___vi",
    path: "/translation",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/translation/index.vue")
  },
  {
    name: "translation___en",
    path: "/en/translation",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/translation/index.vue")
  },
  {
    name: "activity-log___vi",
    path: "/activity-log",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/activity-log/index.vue")
  },
  {
    name: "activity-log___en",
    path: "/en/activity-log",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/activity-log/index.vue")
  },
  {
    name: "organization___vi",
    path: "/organization",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/organization/index.vue")
  },
  {
    name: "organization___en",
    path: "/en/organization",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/organization/index.vue")
  },
  {
    name: "academic-year___vi",
    path: "/academic-year",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/academic-year/index.vue")
  },
  {
    name: "academic-year___en",
    path: "/en/academic-year",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/academic-year/index.vue")
  },
  {
    name: "system-config___vi",
    path: "/system-config",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/system-config/index.vue")
  },
  {
    name: "system-config___en",
    path: "/en/system-config",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/system-config/index.vue")
  },
  {
    name: "product-review___vi",
    path: "/product-review",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/product-review/index.vue")
  },
  {
    name: "product-review___en",
    path: "/en/product-review",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/product-review/index.vue")
  },
  {
    name: "question-share___vi",
    path: "/question-share",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/question-share/index.vue")
  },
  {
    name: "question-share___en",
    path: "/en/question-share",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/question-share/index.vue")
  },
  {
    name: "school-org-structure___vi",
    path: "/school/org-structure",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/school/org-structure.vue")
  },
  {
    name: "school-org-structure___en",
    path: "/en/school/org-structure",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/school/org-structure.vue")
  },
  {
    name: "category-config___vi",
    path: "/category-config",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/category-config/index.vue")
  },
  {
    name: "category-config___en",
    path: "/en/category-config",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/category-config/index.vue")
  },
  {
    name: "user-identifier___vi",
    path: "/user-identifier",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/user-identifier/index.vue")
  },
  {
    name: "user-identifier___en",
    path: "/en/user-identifier",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/user-identifier/index.vue")
  },
  {
    name: "tracking-leaderboard___vi",
    path: "/tracking/leaderboard",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/tracking/leaderboard/index.vue")
  },
  {
    name: "tracking-leaderboard___en",
    path: "/en/tracking/leaderboard",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/tracking/leaderboard/index.vue")
  },
  {
    name: "static-page-pageKey___vi",
    path: "/static-page/:pageKey()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/static-page/[pageKey]/index.vue")
  },
  {
    name: "static-page-pageKey___en",
    path: "/en/static-page/:pageKey()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/static-page/[pageKey]/index.vue")
  },
  {
    name: "tracking-activity-log___vi",
    path: "/tracking/activity-log",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/tracking/activity-log/index.vue")
  },
  {
    name: "tracking-activity-log___en",
    path: "/en/tracking/activity-log",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/tracking/activity-log/index.vue")
  },
  {
    name: "tracking-activity-stats___vi",
    path: "/tracking/activity-stats",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/tracking/activity-stats/index.vue")
  },
  {
    name: "tracking-activity-stats___en",
    path: "/en/tracking/activity-stats",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/tracking/activity-stats/index.vue")
  },
  {
    name: "consultation-registration___vi",
    path: "/consultation-registration",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/consultation-registration/index.vue")
  },
  {
    name: "consultation-registration___en",
    path: "/en/consultation-registration",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/consultation-registration/index.vue")
  },
  {
    name: "static-page-pageKey-sectionKey___vi",
    path: "/static-page/:pageKey()/:sectionKey()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/static-page/[pageKey]/[sectionKey].vue")
  },
  {
    name: "static-page-pageKey-sectionKey___en",
    path: "/en/static-page/:pageKey()/:sectionKey()",
    component: () => import("D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/pages/static-page/[pageKey]/[sectionKey].vue")
  }
]